import { printMoney, cartGetQuantityOfVariant, Variant } from '@process-creative/slate-theme-tools';
import { CLASS_SELECTED, CLASS_THUMB_INITIALISED, CLASS_TOGGLED, CLASS_HIDDEN, CLASS_HOVER, CLASS_INITIALISED, CLASS_VISIBLE, CLASS_ACTIVE, CLASS_NEXT_ACTIVE, CLASS_PREV_ACTIVE, CLASS_CAROUSEL_BEGINNING, CLASS_CAROUSEL_END } from "../../tools/constants/classes";
import { ProductForm, SEL_FORM_CONTAINER } from "./product-form";

// Selectors
export const SELECTOR_THUMBNAIL = '[data-product-thumbnail]';
export const SELECTOR_ADD_FORM = '[data-product-add-form]';
const SELECTOR_TOGGLE_FORM = '[data-product-form-toggle]';
const SELECTOR_PSEUDO_VARIANT = '[data-pseudo-variant]';
const SELECTOR_PSEUDO_VARIANTS = '[data-pseudo-variants]';
const SELECTOR_PSEUDO_VARIANT_WRAPPER = '[data-pseudo-variant-wrapper]';
const SELECTOR_PSEUDO_LABEL = '[data-pseudo-label]';
const SELECTOR_PSEUDO_SWATCH_LABEL = '[data-swatch-label]';
const SELECTOR_PSEUDO_SWATCH_DROPDOWN = '[data-swatch-dropdown]';
const SELECTOR_FORM_SWATCH_DROPDOWN = '.o-variant-selector__dropdown';
const SELECTOR_PSEUDO_SWATCH_VARIANTS= '[data-selected-pseudo-variant]';
const SELECTOR_PRODUCT_SWATCH_VARIANTS = '[data-product-swatch-variants]';
const SELECTOR_PRODUCT_IMAGE = '[data-image]';
const SELECTOR_PRODUCT_TITLE = '[data-thumbnail-title]';
const SELECTOR_PRODUCT_LINK = '[data-thumbnail-link]';
const SELECTOR_PRODUCT_SELECTED_ID = '[data-variant-selected-id]';
const SELECTOR_VARIANT_PRODUCT_TITLE = '[data-product-label]';

const SEL_MOBILE_POPUP = '[data-mobile-popup-contianer]';
const SEL_MOBILE_POPUP_TOGGLE = '[data-mobile-popup-toggle]';
const SEL_ADD_BUTTON = '[data-product-quick-add]';

const SEL_SUBSCRIBE_BTN = '[data-subscribe]';
const SEL_ONE_TIME_BTN = '[data-one-time]';

const ATTR_PSEUDO_LABEL = 'data-pseudo-label';
const ATTR_PSEUDO_VARIANT = 'data-pseudo-variant';
const ATTR_PSEUDO_LINK = 'data-pseudo-link';
const ATTR_ID = 'data-id';
const ATTR_PRODUCT_TITLE = 'data-product-label';
const ACTIVE_THUMBNAILS: ProductThumbnail[] = [];

export class ProductThumbnail {
  public container: HTMLElement;
  private formElement: HTMLFormElement | null = null;
  private form: ProductForm | null = null;
  private toggleFormBtns: NodeListOf<HTMLButtonElement> | null = null;
  private pseudoVariantBtns: NodeListOf<HTMLButtonElement> | null = null;
  private pseudoVariantLabel: NodeListOf<HTMLButtonElement> | null = null;
  private pseudoVariantSwatch: HTMLElement| null = null;
  private mainImage: HTMLElement | null = null;
  private mobileMainImage: HTMLElement | null = null;

  private mobilePopup: HTMLElement | null = null;
  private mobilePopupToggles: NodeListOf<HTMLButtonElement> | null = null;

  private addButton: HTMLButtonElement | null = null;

  private subscribeBtn: HTMLButtonElement | null = null;
  private oneTimeBtn: HTMLButtonElement | null = null;
  private hasSellingPlan: Boolean;
  private sellingPlanId: String;
  private sellingPlans: HTMLSelectElement | null = null;
  private customRetailPercentage: number | null = 0;
  private customRetailWording: string | null = null;

  constructor(container: HTMLElement) {
    this.container = container;
    this.formElement = container.querySelector(SEL_FORM_CONTAINER);
    this.toggleFormBtns = container.querySelectorAll(SELECTOR_TOGGLE_FORM);
    this.pseudoVariantBtns = container.querySelectorAll(SELECTOR_PSEUDO_VARIANT);
    this.pseudoVariantLabel = container.querySelectorAll(SELECTOR_PSEUDO_LABEL);
    this.pseudoVariantSwatch = container.querySelector(SELECTOR_PSEUDO_SWATCH_LABEL);
    this.mainImage = container.querySelector('.o-product-thumbnail__image-container');
    this.mobileMainImage = container.querySelector('.o-product-thumbnail__mobile-popup-image-container .o-responsive-image-container');

    this.mobilePopup = container.querySelector(SEL_MOBILE_POPUP);
    this.mobilePopupToggles = container.querySelectorAll(SEL_MOBILE_POPUP_TOGGLE);

    this.addButton = container.querySelector(SEL_ADD_BUTTON);

    this.subscribeBtn = container.querySelector(SEL_SUBSCRIBE_BTN);
    this.oneTimeBtn = container.querySelector(SEL_ONE_TIME_BTN);
    this.sellingPlans = container.querySelector<HTMLSelectElement>('[data-selling-plans]');

    this.customRetailPercentage = Number(container.getAttribute('data-custom-percentage'));

    if (this.sellingPlans) {
      this.sellingPlanId = this.sellingPlans.value;
    }
    
    
    this.attachEvents();
  }

  updateVariantId(e) {
    // this.form?.onVariantChange()
  }

  attachEvents() {
    if (this.formElement) {
      this.form = new ProductForm(this.formElement);
      this.formElement?.querySelector(SELECTOR_PSEUDO_SWATCH_DROPDOWN)?.addEventListener('change', this.updateVariantId)
    }

    this.mobilePopupToggles?.forEach(toggle => {
      toggle.addEventListener('click', (e) => this.toggleMobileForme(e));
    });

    this.container?.addEventListener('mouseenter', () => { 
      this.container.classList.add(CLASS_HOVER);
    });

    this.container?.addEventListener('mouseleave', () => {
      this.container.classList.remove(CLASS_HOVER);
    });
    
    if (this.pseudoVariantBtns) {
      Array.from(this.pseudoVariantBtns).forEach(btn => {
        btn.addEventListener('click', (e) => this.handlePseudoVariantClick(e, btn));
      });
    }

    this.swatchDropdown();

    setTimeout(() => {
      this.initBadgesCarousel();
    }, 1000);
    

    this.subscribeBtn?.addEventListener('click', (e) => { this.toggleSubscribe(e) });
    this.oneTimeBtn?.addEventListener('click', (e) => { this.toggleOneTime(e) });

    if (this.subscribeBtn) {
      this.hasSellingPlan = true;
    } else {
      this.hasSellingPlan = false;
    }

    if (this.sellingPlans) {

      this.sellingPlans.addEventListener('change', () => {
 
        this.setSubscriptionPlan();
      })
    }

    // Listen for the custom event
    this.container.addEventListener('updatePricing', (detail) => {
      this.updatePricing(detail);
    });
  }


  // Toggle Mobile Form
  toggleMobileForme(e) {
    e.preventDefault();
    this.mobilePopup?.classList.toggle('is-open');
  }

  updatePricing(detail) {

    const currVar = detail.detail.variant;

    let subscriptionPlans = ''
    let adjustedPrice = 0
    let adjustedComparePrice = 0
    let compareAtPrice = currVar.compare_at_price;
    let productPrice = currVar.price;


    if (currVar.custom_retail_compare) {
      compareAtPrice = currVar.custom_retail_compare
    }

    if (currVar.custom_retail_percentage) {
      this.customRetailPercentage = currVar.custom_retail_percentage
      this.container.classList.add("has-custom-percentage");
    } else {
      this.customRetailPercentage = 0;
      this.container.classList.remove("has-custom-percentage");
    }

    if (currVar.custom_retail_wording) {
      this.customRetailWording = currVar.custom_retail_wording
    }

    // Add subscription plans
    currVar.selling_plan_allocations.forEach((el, i) => {

      if (i === 0) {

        subscriptionPlans += `<option value="${el.selling_plan_id}" selected></option>`

        adjustedPrice = el.price;
        adjustedComparePrice = el.compare_at_price;

        const sellingPlanContainer = this.container?.querySelector<HTMLElement>('[data-selling-plan-container]');

        if (this.hasSellingPlan) {
          if (!sellingPlanContainer) return;
          sellingPlanContainer.innerHTML = `<input name="selling_plan" type="hidden" value="${el.selling_plan_id}">`
        } else {
          if (!sellingPlanContainer) return;
          sellingPlanContainer.innerHTML = '';
        }
      }
    });


    const variantSelectElement = this.container.querySelector<HTMLSelectElement>('.o-variant-selector__dropdown');

    if (variantSelectElement) {
      for (const option of variantSelectElement.options) {
        if (Number(option.value) === Number(currVar.id)) {
          variantSelectElement.value = option.value;
          break;
        }
      }
    }
    
    let shopifyFormInput = this.container?.querySelector('input[name="product-id"]') as HTMLInputElement;
    if(shopifyFormInput) shopifyFormInput.value = currVar.id;

    if (this.sellingPlans) {
      this.sellingPlans.innerHTML = subscriptionPlans;
    }

    const priceWrappers = this.container?.querySelectorAll('.o-product-thumbnail__pricing.is-subscribe');
    const nativePriceWrappers = this.container?.querySelectorAll('.o-product-thumbnail__price-wrapper.is-subscribe');
    const thumbnailPrice = this.container?.querySelectorAll('[data-subscription-price]');
    const thumbnailPriceAdjusted = this.container?.querySelectorAll('[data-subscription-price-adjusted]');
    const sellingPlanPercent = this.container?.querySelectorAll('[data-subscription-percent]');
    const productThumbnailInner = this.container.querySelector('.o-product-thumbnail__inner');
    const customPercentBadgeContainer = this.container?.querySelector('.o-product-thumbnail__badge.is-custom-percentage');

    let percentDiscount = ((adjustedComparePrice - adjustedPrice) / adjustedComparePrice) * 100;

    let customPercentBadgeHTML = ``;

    if (this.customRetailPercentage && this.customRetailPercentage > 0) {
      customPercentBadgeHTML = `
        <div class="o-product-thumbnail__badge o-paragraph--3 is-custom-percentage">${this.customRetailPercentage}% off</div>
      `;
    } else {
      customPercentBadgeHTML = ``;
    }

    if (!customPercentBadgeContainer) {
      
      if (customPercentBadgeHTML != ``) {
        if (productThumbnailInner) {
          productThumbnailInner.insertAdjacentHTML('afterbegin', customPercentBadgeHTML);
        }
      } else {
        if (productThumbnailInner) {
          productThumbnailInner.querySelector('.o-product-thumbnail__badge.is-custom-percentage')?.remove();
        }
      }
    } else {
      if (customPercentBadgeHTML != ``) {

      } else {
        if (productThumbnailInner) {
          productThumbnailInner.querySelector('.o-product-thumbnail__badge.is-custom-percentage')?.remove();
        }
      }
    }

    if (sellingPlanPercent) {
      sellingPlanPercent.forEach(i => {
        if (this.customRetailPercentage && this.customRetailPercentage > 0) {
          i.innerHTML = `${this.customRetailPercentage}% ${this.customRetailWording}`
        } else {
          i.innerHTML = `${percentDiscount}%`
        }
      });
    }

    if (thumbnailPrice) {
      thumbnailPrice.forEach(i => {
        i.innerHTML = `${printMoney(Number(adjustedComparePrice))}`;
      });
    }

    if (thumbnailPriceAdjusted) {
      thumbnailPriceAdjusted.forEach(i => {

        i.innerHTML = `
          ${printMoney(Number(adjustedPrice))}
        `;

      });
    }

    if (priceWrappers) {
      priceWrappers.forEach(priceWrapper => {
        const price = priceWrapper.querySelector('.o-pricing__price');
        const compare = priceWrapper.querySelector('.o-pricing__compare');

        if (price) {
          price.innerHTML = `${printMoney(Number(productPrice))}`;
        }
        if (compare) {
          if (compareAtPrice > 0) {
            compare.innerHTML = `${printMoney(Number(compareAtPrice))}`;
          } else {
            compare.innerHTML = ``;
          }
          
        }
      });
    }

    if (nativePriceWrappers) {
      nativePriceWrappers.forEach(priceWrapper => {
        const compare = priceWrapper.querySelector('.o-pricing__compare');

        if (compare) {
          if (compareAtPrice > 0) {
            compare.innerHTML = `${printMoney(Number(compareAtPrice))}`;
          } else {
            compare.innerHTML = ``;
          }
        }
      });
    }

    let featuredImage = '';

    if (this.mainImage && this.mobileMainImage && currVar.featured_image) {

      if (currVar.featured_image?.src) {
        featuredImage = currVar.featured_image.src
      } else if (currVar.featured_image) {
        featuredImage = currVar.featured_image
      } else {
        featuredImage = ''
      }

      this.updateInitialImage(this.mainImage, featuredImage);
      this.updateInitialImage(this.mobileMainImage, featuredImage);
    }

    this.checkButtonState(currVar);

    this.setSubscriptionPlan();

    // Set Default Subscribe / one time option based on selling plans.
    if (currVar.selling_plan_allocations.length === 0) {
      this.oneTimeBtn?.click();
      this.oneTimeBtn?.parentElement?.classList.add('is-hidden');
      this.subscribeBtn?.setAttribute('disabled', 'disabled');
      this.container.classList.remove('has-selling-plan');
    } else {
      this.subscribeBtn?.removeAttribute('disabled');
      this.oneTimeBtn?.parentElement?.classList.remove('is-hidden');
      this.subscribeBtn?.click();
      this.container.classList.add('has-selling-plan');
    }
  }

  updateInitialImage(el: Element, src: string): void {
    if (!el) return;
  
    let initialImage = el.querySelector<HTMLPictureElement>('picture');
  
    if (!initialImage) return;
  
    const newImageHTML = `
      <picture>
        <img src="${String(src.replace('.jpg','_x800.jpg'))}" class="o-responsive-image">
      </picture>
    `;
    
    // const imageHTMLNoCDN = newImageHTML.replace(/\/\/cdn.shopify.com/g, '');
  
    // Create a new image element
    const template = document.createElement('template');
    template.innerHTML = newImageHTML.trim();
    const newImage = template.content.firstChild as HTMLElement;
    const newImageSrc = newImage.querySelector<HTMLImageElement>('img');
  
    if (!newImageSrc) return;
  
    // Hide the new image initially
    newImage.style.opacity = '0';
  
    // Insert the new image as a sibling next to the initial image
    initialImage.after(newImage);
  
    // Trigger a reflow to ensure the transition works
    initialImage.offsetWidth; // This is a hack to trigger a reflow
  
    newImageSrc.onload = () => {
      newImage.style.transition = 'opacity 0.5s';
      newImage.style.opacity = '1';
  
      initialImage?.remove();
      initialImage = newImage as HTMLPictureElement;
    };
  }

  setSubscriptionPlan() {

    this.sellingPlanId = String(this.sellingPlans?.value);

    const sellingPlanContainer = this.container?.querySelector<HTMLElement>('[data-selling-plan-container]');

    const sellingPlanHtml = `
      <input name="selling_plan" type="hidden" value="${this.sellingPlanId}">
    `

    if (this.hasSellingPlan) {
      if (!sellingPlanContainer) return;
      sellingPlanContainer.innerHTML = sellingPlanHtml
    } else {
      if (!sellingPlanContainer) return;
      sellingPlanContainer.innerHTML = '';
    }
  }

  toggleSubscribe(e: Event) {
    e.preventDefault();
    const el = e.currentTarget as HTMLButtonElement;
    el.classList.add('is-active');
    this.oneTimeBtn?.classList.remove('is-active');
    this.hasSellingPlan = true;
    this.container.classList.add('has-selling-plan');
    this.setSubscriptionPlan();
  }

  toggleOneTime(e: Event) {
    e.preventDefault();
    const el = e.currentTarget as HTMLButtonElement;
    el.classList.add('is-active');
    this.subscribeBtn?.classList.remove('is-active');
    this.hasSellingPlan = false;

    this.container.classList.remove('has-selling-plan');

    this.setSubscriptionPlan();
  }

  swatchDropdown() {
    let selectedVariantsDropdownEl = this.formElement?.querySelector(SELECTOR_PSEUDO_SWATCH_DROPDOWN) as HTMLElement;
    let selectedVariantEl = this.formElement?.querySelector(SELECTOR_PSEUDO_SWATCH_VARIANTS) as HTMLInputElement;
    const selectedVariantsDropdownFormEl = this.formElement?.querySelector(SELECTOR_FORM_SWATCH_DROPDOWN) as HTMLElement;

    if(selectedVariantsDropdownEl) selectedVariantsDropdownEl.addEventListener('change', (e) => {
      e.preventDefault();
      const sel = e.currentTarget as HTMLSelectElement;
      let selectedId = sel.options[sel.selectedIndex].getAttribute(ATTR_ID) as any;

      if(selectedVariantEl && selectedId) selectedVariantEl.value = selectedId;
      //@ts-ignore
      if(selectedVariantsDropdownFormEl && selectedId)  selectedVariantsDropdownFormEl.value = selectedId;
    })
  }

  handlePseudoVariantClick(e: Event, pseudoVariantBtn: HTMLButtonElement) {
    e.preventDefault();
    
    let optionElements = '';
    let optionElementsID = '';

    let optionElementSwatches = '';
    let optionElementButtons = '';
    
    if (!this.pseudoVariantBtns || pseudoVariantBtn === undefined) return;
    const selectedVariantEl = this.formElement?.querySelector(SELECTOR_PSEUDO_SWATCH_VARIANTS) as HTMLInputElement;
    const selectInput = this.formElement?.querySelector(SELECTOR_PRODUCT_SELECTED_ID) as HTMLInputElement;
    const selectedVariantLabel = pseudoVariantBtn?.getAttribute(ATTR_PSEUDO_LABEL) as string;
    const selectedProductLabel = pseudoVariantBtn?.getAttribute(ATTR_PRODUCT_TITLE) as string;
    const selectedProductLink = pseudoVariantBtn?.getAttribute(ATTR_PSEUDO_LINK) as string;
    const selectedVariants = pseudoVariantBtn?.querySelector(SELECTOR_PSEUDO_VARIANTS) as any;
    const thumbnailTitles = this.container.querySelectorAll(SELECTOR_PRODUCT_TITLE);
    const thumbnailLinks = this.container.querySelectorAll(SELECTOR_PRODUCT_LINK);
    
    const pseudoVariantBtnVariantId = pseudoVariantBtn.getAttribute(ATTR_PSEUDO_VARIANT);
    const selectedVariantsDropdownEl = this.formElement?.querySelector(SELECTOR_PSEUDO_SWATCH_DROPDOWN) as HTMLElement;
    const selectedVariantsDropdownFormEl = this.formElement?.querySelector(SELECTOR_FORM_SWATCH_DROPDOWN) as HTMLElement;
    const jsonVariants = JSON.parse(selectedVariants?.innerHTML);

    const btnWrapper = pseudoVariantBtn.closest(SELECTOR_PSEUDO_VARIANT_WRAPPER);

    // deselect all pseudovariant swatches
    Array.from(this.pseudoVariantBtns).forEach(btn => {
      btn.closest(SELECTOR_PSEUDO_VARIANT_WRAPPER)?.classList.remove(CLASS_SELECTED);
    });

    let subscriptionPlans = '';
    let swatchImage = '';

    // generate variant selector for newly selected pseudovariant
    if(selectedVariants) {
      if(!jsonVariants) return;
      

      jsonVariants.variants.forEach(variant => {

        if (variant.custom_retail_percentage) {
          this.customRetailPercentage = Number(variant.custom_retail_percentage)
          this.container.classList.add("has-custom-percentage");
        } else {
          this.customRetailPercentage = 0;
          this.container.classList.remove("has-custom-percentage");
        }
    
        if (variant.custom_retail_wording) {
          this.customRetailWording = variant.custom_retail_wording
        }

        if (variant.swatch_image?.src) {
          swatchImage = variant.swatch_image.src
        } else if (variant.swatch_image) {
          swatchImage = variant.swatch_image
        } else {
          swatchImage = ''
        }

        optionElements += `<option value="${variant.handle}" data-id="${variant.id}">${variant.title}</option>`;
        optionElementsID += `<option value="${variant.id}">${variant.title}</option>`;

        optionElementSwatches += `
          <div class="o-swatches__swatch-button-wrap is-image ${variant.handle}" data-thumbs-carousel-item="">
            <button title="${variant.title}" type="button" class="o-swatches__swatch-button s-swatch--${variant.handle} is-selected"
              data-swatch-object data-value="${variant.handle}" data-swatch-position="1" data-title="${variant.title}">
              <img class="o-swatches__image o-swatches__image--first" src="${String(swatchImage).replace('.jpg', '_100x.jpg')}">
              <img class="o-swatches__image o-swatches__image--second" src="${String(swatchImage).replace('.jpg', '_100x.jpg')}">
            </button>
          </div>
        `

        // Add subscription plans
        variant.selling_plan_allocations.forEach((el, i) => {
          

          if (i === 0) {
            subscriptionPlans += `<option value="${el.selling_plan_id}" selected></option>`
            const sellingPlanContainer = this.container?.querySelector<HTMLElement>('[data-selling-plan-container]');

            if (this.hasSellingPlan) {
              if (!sellingPlanContainer) return;
              sellingPlanContainer.innerHTML = `<input name="selling_plan" type="hidden" value="${el.selling_plan_id}">`
            } else {
              if (!sellingPlanContainer) return;
              sellingPlanContainer.innerHTML = '';
            }
          }
        });

        // Set Default Subscribe / one time option based on selling plans.
        if (variant.selling_plan_allocations.length >= 1) {
          this.oneTimeBtn?.click();
          this.oneTimeBtn?.parentElement?.classList.add('is-hidden');
          this.subscribeBtn?.setAttribute('disabled', 'disabled');
          this.container.classList.remove('has-selling-plan');
        } else {
          this.subscribeBtn?.removeAttribute('disabled');
          this.oneTimeBtn?.parentElement?.classList.remove('is-hidden');
          this.subscribeBtn?.click();
          this.container.classList.add('has-selling-plan');
        }
      });
    }

    if (this.sellingPlans) {
      this.sellingPlans.innerHTML = subscriptionPlans;
    }

    // insert newly generated variant selectors
    if(optionElements != '' && selectedVariantsDropdownEl) {
      selectedVariantsDropdownEl.innerHTML = optionElements;
      selectedVariantsDropdownFormEl.innerHTML = optionElementsID;
    }

    if(optionElementsID != '' && selectedVariantsDropdownFormEl) {
      selectedVariantsDropdownFormEl.innerHTML = optionElementsID;
    }

    // Update Variant title, product title, price and product link
    if(this.pseudoVariantSwatch) this.pseudoVariantSwatch.innerHTML = selectedVariantLabel;
    if (thumbnailTitles) thumbnailTitles.forEach(title => {
      title.innerHTML = selectedProductLabel;
    })
    if(thumbnailLinks && selectedProductLink != null) {
      thumbnailLinks.forEach( (thumbnailLink: any) => {
        thumbnailLink.setAttribute('href', selectedProductLink);
      });
    }

    // Update input ID
    if (selectedVariantEl && pseudoVariantBtnVariantId) {
      selectedVariantEl.value = pseudoVariantBtnVariantId;
      if(selectInput) {
        selectInput.value = pseudoVariantBtnVariantId;
      }
    }
    btnWrapper?.classList.add(CLASS_SELECTED);

    // trigger change event to update price TODO
    let shopifyFormInput = this.container?.querySelector('input[name="product-id"]') as HTMLInputElement;
    if(shopifyFormInput) shopifyFormInput.value = jsonVariants.id;

    this.checkButtonState(jsonVariants);

    const swatchesWrappers = this.container?.querySelectorAll('.o-swatches__wrapper:not(.is-pseudo)');

    swatchesWrappers.forEach(item => {
      if (jsonVariants.variants.length == 1) {
        item.classList.add('is-hidden');
      } else {
        item.classList.remove('is-hidden');
        if (item.classList.contains('is-select')) {
          item.innerHTML = `
          <div class="o-swatches o-product-thumbnail__swatches" data-swatches>
            <div class="o-variant-selector o-swatches__variant-selector no-js" data-variant-selector>
              <select name="id" class="o-input o-variant-selector__dropdown">
                ${optionElementsID}
              </select>
            </div>
            <div class="o-swatches__swatches has-js">
              <div class="o-swatches__inner o-swatches__inner-select">
                <div class="o-swatches__swatch is-select" data-swatch data-swatch-position="1">
                  <select class="o-swatches__select o-select" name="option-0" data-swatch-dropdown>
                    ${optionElements}
                  </select>
                </div>
              </div>
            </div>
          </div>
          `
        }

        if (item.classList.contains('is-color')) {
          item.innerHTML = `
          <h6 class="o-swatches__title" data-swatch-title="">Spool and Dispenser</h6>
            <div class="o-swatches o-product-thumbnail__swatches" data-swatches>
              <div class="o-variant-selector o-swatches__variant-selector no-js" data-variant-selector>
                <select name="id" class="o-input o-variant-selector__dropdown">
                  ${optionElementsID}
                </select>
              </div>
              <div class="o-swatches__swatches has-js">
                <div class="o-swatches__inner o-swatches__inner-color">
                  <div class="o-swatches__swatch is-select is-centered" data-swatch="" data-swatch-position="1">
                    <div class="o-swatches__swatch-options is-color">
                      ${optionElementSwatches}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          `
        }
      }
    });

    this.form?.reinitialiseSwatches(jsonVariants);
  }

  // Check button states
  checkButtonState(data: any) {
    const buttonLabels = this.addButton?.querySelectorAll('[data-label-element]');
    
    if (data.available === true) {

      this.addButton?.classList.add('is-label-animated');
      this.addButton?.classList.remove('is-disabled');
      this.addButton?.removeAttribute('disabled');
      buttonLabels?.forEach(label => {
        label.innerHTML = 'Quick add'
      });
    } else {

      this.addButton?.classList.remove('is-label-animated');
      this.addButton?.classList.add('is-disabled');
      this.addButton?.setAttribute('disabled', 'disabled');
      buttonLabels?.forEach(label => {
        label.innerHTML = 'Out of stock'
      });
    }
  }

  initBadgesCarousel = () => {

    // Selectors
    const SEL_CONTAINER = '[data-thumbs-carousel-container]';
    const SEL_CAROUSEL = '[data-thumbs-carousel]';
    const SEL_PREV = '[data-thumbs-carousel-prev]';
    const SEL_NEXT = '[data-thumbs-carousel-next]';
    const SEL_ITEM = '[data-thumbs-carousel-item]';
    const SEL_PROGRESS = '[data-thumbs-carousel-progress-bar]';

    // Attributes
    const ATTR_GAP = 'data-gap';
    const ATTR_DISABLE_MOB = 'data-thumbs-carousel-disabled-mobile';
    const ATTR_RESIZE = 'data-resize';
    const ATTR_NO_TOUCH = 'data-no-touch';

    const cssCarouselContainers = this.container.querySelectorAll<HTMLElement>(SEL_CONTAINER);

    cssCarouselContainers.forEach((container: HTMLElement) => {

      if (container.classList.contains(CLASS_INITIALISED)) {
        return;
      } else {
        container.classList.add(CLASS_INITIALISED);
      }

      const carousel = container.querySelector<HTMLElement>(SEL_CAROUSEL);
      const prevBtn = container.querySelector<HTMLElement>(SEL_PREV);
      const nextBtn = container.querySelector<HTMLElement>(SEL_NEXT);
      const carouselItems = container.querySelectorAll<HTMLElement>(SEL_ITEM);
      const gapAmount = Number(container.getAttribute(ATTR_GAP));
      const noTouch = container.hasAttribute(ATTR_NO_TOUCH);
      const progressBar = container.querySelector<HTMLElement>(SEL_PROGRESS);

      if (carouselItems.length === 0) {
        container.classList.remove(CLASS_VISIBLE);
        return;
      } else {
        container.classList.add(CLASS_VISIBLE);
      }

      let touchStartX = 0;
      let currentPosition = 0;
      let maxPosition = 0;
      let containerWidth = 0;
      let carouselWidth = 0;
      let resizeTimer: ReturnType<typeof setTimeout>;
      let gap = 0;
      let carouselEnd = false;
      let translateX: number;
      let progressPercentage: number;

      container.classList.add(CLASS_INITIALISED);

      const updateCarousel = (): void => {

        if (container.hasAttribute(ATTR_DISABLE_MOB) && window.outerWidth < 750) {
          return;
        }

        if (!carousel) return;
        containerWidth = container.clientWidth;
        carouselWidth = Number(carousel.clientWidth);
        const itemWidth = getItemWidth(0);
        const numVisibleItems = 3;

        if (window.outerWidth >= 750) {
          gap = gapAmount * 2;
        } else {
          gap = gapAmount;
        }

        const totalItemsWidth = Array.from(carouselItems).reduce((sum, item) => {
          return sum + itemWidth + gap;
        }, 0);

        const containerVisibleWidth = numVisibleItems * itemWidth + (numVisibleItems - 1) * gap;
        maxPosition = Math.max(0, Math.ceil((totalItemsWidth - containerVisibleWidth) / (itemWidth + gap)));

        if (containerVisibleWidth < containerWidth) {
          maxPosition = Math.max(maxPosition, currentPosition);
        }

        currentPosition = Math.min(maxPosition, Math.max(0, currentPosition));

        const getPositionOffset = (index: number): number => {
          return index * (itemWidth + gap);
        };

        if (carouselWidth < containerWidth) {
          container.classList.add(CLASS_CAROUSEL_BEGINNING);
          container.classList.add(CLASS_CAROUSEL_END);
          carousel.style.transform = `translateX(0)`;
          return;
        } else {
          if (getPositionOffset(currentPosition) > (totalItemsWidth - containerWidth)) {
            carouselEnd = true;
            translateX = -(totalItemsWidth - containerWidth);
          } else {
            translateX = -getPositionOffset(currentPosition);
          }
        }

        carousel.style.transform = `translateX(${translateX}px)`;

        updateNavigation();
        updateHeight();
      };

      const updateHeight = (): void => {
        if (container.hasAttribute(ATTR_RESIZE) && container.getAttribute(ATTR_RESIZE) === 'true') {
          const activeItem = carouselItems[currentPosition].children[0] as HTMLElement;
          if (activeItem && carousel) {
            carousel.style.height = `${activeItem.offsetHeight}px`;
          }
        }
      };

      const getItemWidth = (index: number): number => {
        const item = carouselItems[index];
        const itemStyle = getComputedStyle(item);
        const itemMarginLeft = parseInt(itemStyle.marginLeft || '0');
        const itemMarginRight = parseInt(itemStyle.marginRight || '0');
        const itemPaddingLeft = parseInt(itemStyle.paddingLeft || '0');
        const itemPaddingRight = parseInt(itemStyle.paddingRight || '0');

        return item.offsetWidth + itemMarginLeft + itemMarginRight + itemPaddingLeft + itemPaddingRight;
      };

      const updateNavigation = () => {
        progressPercentage = (currentPosition / maxPosition) * 100;

        if (carouselEnd) {
          progressPercentage = 100;
        }

        if (progressBar) {
          progressBar.style.width = `${progressPercentage}%`;

          if (progressPercentage > 0) {
            progressBar.parentElement?.classList.add('is-visible');
            progressBar.parentElement?.parentElement?.classList.add('has-progress');
          } else {
            progressBar.parentElement?.classList.remove('is-visible');
            progressBar.parentElement?.parentElement?.classList.remove('has-progress');
          }
        }

        container.classList.toggle(CLASS_CAROUSEL_BEGINNING, currentPosition === 0);
        container.classList.toggle(CLASS_CAROUSEL_END, carouselEnd);
      };

      prevBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        if (currentPosition > 0) {
          carouselEnd = false;
          currentPosition -= 3;
          currentPosition = Math.max(0, currentPosition);
          updateCarousel();
        }
      });

      nextBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        if (currentPosition < maxPosition) {
          currentPosition += 3;
          currentPosition = Math.min(maxPosition, currentPosition);
          updateCarousel();
        }
      });

      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          updateCarousel();
        }, 500);
      });

      container.addEventListener('touchstart', (e) => {
        if (noTouch) return;
        touchStartX = e.touches[0].clientX;
      }, { passive: true });

      container.addEventListener('touchmove', (e) => {
        if (noTouch) return;
        const touchEndX = e.touches[0].clientX;
        const touchDeltaX = touchEndX - touchStartX;

        if (Math.abs(touchDeltaX) > 70) {
          if (touchDeltaX > 0 && currentPosition > 0) {
            carouselEnd = false;
            currentPosition -= 3;
            currentPosition = Math.max(0, currentPosition);
          } else if (touchDeltaX < 0 && currentPosition < maxPosition && !carouselEnd) {
            currentPosition += 3;
            currentPosition = Math.min(maxPosition, currentPosition);
          }

          updateCarousel();
          touchStartX = touchEndX;
        }
      }, { passive: true });

      updateCarousel();
    });
  }

   
  detatchEvents() {
    if (this.form) {
      this.form.detatchEvents();
    }
  }
}

export const initialiseProductThumbnails = () => {
  [...ACTIVE_THUMBNAILS].forEach(thumbnail => {
    if (thumbnail.container) return;
    thumbnail.detatchEvents();
  });

  document.querySelectorAll<HTMLElement>(SELECTOR_THUMBNAIL).forEach(thumbnail => {
    if (thumbnail.classList.contains(CLASS_THUMB_INITIALISED)) return;
    thumbnail.classList.add(CLASS_THUMB_INITIALISED);
    new ProductThumbnail(thumbnail);
  });

};

initialiseProductThumbnails();